/**
 * Returns the PISA API base URL from environment configuration.
 *
 * This module exists to provide a single, mockable source for the PISA base URL.
 * In Jest tests, mock this module to provide test values:
 *
 * @example
 * jest.mock('@/utils/getPisaBaseUrl', () => ({
 *   PISA_BASE_URL: 'https://test-api.example.com'
 * }))
 */
export const PISA_BASE_URL =
  import.meta.env.VITE_PISA_BASE_URL ||
  'https://api.justrelate.com/neocrm/instance'
